import React, { Component } from 'react';
import styles from './Loader.scss';

class Loader extends Component {

  state = {
    active: false,
    remaining: 100
  }

  componentDidMount() {
    if (this.props.active) {
      this.start();
    }
  }

  handleTransitionEnd = (e) => {
    if (this.state.remaining <= 0 && e.propertyName === 'transform') {
      this.setState({
        active: false
      });
      this.bar.removeEventListener('transitionend', this.handleTransitionEnd);
    }
  }

  start = () => {
    this.setState({
      active: true,
      remaining: this.state.remaining || 100
    });
    this.inc();
  }

  inc = () => {
    if (this.state.remaining > 10) {
      this.setState({
        remaining: this.state.remaining - ~~(5 + Math.random() * this.state.remaining / 5)
      });
    }

    this.timer = setTimeout(
      this.inc, 150
    );
  }

  done = () => {
    clearTimeout(this.timer);
    this.setState(
      { remaining: 0 },
      () => { this.bar.addEventListener('transitionend', this.handleTransitionEnd); }
    );
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.active && !this.props.active) {
      this.start();
    }
    if (!nextProps.active && this.props.active) {
      this.done();
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  getBarRef = (r) => {
    this.bar = r;
  }

  render() {
    return (
      <div className={styles.loader} id={this.id}>
        <div
          ref={this.getBarRef}
          className={styles.bar}
          style={{
            opacity: this.state.active ? 1 : 0,
            transform: `translateX(-${this.state.remaining}%)`,
            transition: `transform opacity ${this.state.active}` && this.state.remaining < 100 ? '.3s' : '0s'
          }}
        />
      </div>
    );
  }
}

export default Loader;



// WEBPACK FOOTER //
// ./src/components/common/Loader/Loader.js